<template>
  <div>
    <main class="flex flex__column flex__spaced">
      <nav class="nav flex flex__spaced flex__item-center fixed-nav">
        <div
          class="flex flex__item-center flex__gap-3"
          :class="{
            'stagger__in-ease-left--1': $route.name === 'landing-page'
          }"
        >
          <router-link :to="{ name: 'landing-page' }">
            <img
              src="@/assets/icons/infohub-blue-logo.svg"
              alt="infohob-logo"
            />
          </router-link>
          <div class="flex flex__item-center flex__gap-3 m-d-none">
            <router-link
              :to="{ name: link }"
              v-for="({ link, name }, index) in navLinks"
              :key="index"
              class="fs-16 nav__link fw-500 text__nav-grey"
            >
              {{ name }}
            </router-link>
          </div>
        </div>
        <div
          class="flex flex__items-center"
          :class="{
            'stagger__in-ease-right--1': $route.name === 'landing-page'
          }"
        >
          <Button
            theme="blue"
            class="m-d-none w-14 ml-3"
            :mobile="true"
            @click="$router.push('/job-seeker/login')"
          >
            Log In
          </Button>

          <Button
            @click="$router.push({ name: 'contact-us' })"
            type="bordered"
            theme="purple"
            class="m-d-none w-14 ml-3"
          >
            Get in touch
          </Button>

          <button
            @click="showMenu = !showMenu"
            class="d-none hamburger__icon m-flex m-flex__column"
          >
            <div v-for="n in 3" :key="n" class="hamburger__icon-item" />
          </button>
        </div>
      </nav>
      <section class="after-fixed-header">
        <slot></slot>
      </section>
      <Footer />
      <div class="u-fixed auto__scroller cursor-pointer" @click="scrollToTop">
        <img src="@/assets/icons/scroll-up-icon.svg" alt="scroll-up-icon" />
      </div>
    </main>

    <div
      class="nav__menu-slider fixed-menu-slider"
      :class="{ active: showMenu }"
    >
      <div class="nav__menu-slider__overlay" @click="showMenu = !showMenu" />
      <div class="nav__menu-slider__card">
        <div class="mb-10 nav__menu-slider__items">
          <router-link
            class="nav__menu-slider__item d-block text__nav-grey"
            v-for="({ link, name }, index) in navLinks"
            :key="index"
            :to="{ name: link }"
          >
            {{ name }}
          </router-link>

          <router-link
            class="nav__menu-slider__item d-block text__nav-grey"
            to="/job-seeker/login"
          >
            Login
          </router-link>

          <router-link
            class="nav__menu-slider__item d-block text__nav-grey"
            :to="{ name: 'contact-us' }"
          >
            Get in touch
          </router-link>
        </div>

        <div class="mx-1 mb-1 nav__menu-slider__bottom">
          <div>
            <p class="fs-14 fw-500 mb-2" style="color: #101828">
              Follow us on LinkedIn to get latest updates
            </p>
            <div class="flex flex__center">
              <svg
                width="50"
                height="12"
                viewBox="0 0 50 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_4158_4439)">
                  <path
                    d="M48.7683 10.3727C48.5536 10.3748 48.3484 10.4618 48.1977 10.6147C48.0469 10.7677 47.9629 10.9741 47.9639 11.1888C47.9649 11.4035 48.051 11.6091 48.2032 11.7606C48.3554 11.9121 48.5614 11.9971 48.7761 11.9971C48.9908 11.9971 49.1968 11.9121 49.349 11.7606C49.5012 11.6091 49.5873 11.4035 49.5883 11.1888C49.5893 10.9741 49.5053 10.7677 49.3546 10.6147C49.2038 10.4618 48.9986 10.3748 48.7839 10.3727H48.7683ZM48.7683 11.9041C48.6275 11.9065 48.4891 11.867 48.3707 11.7907C48.2523 11.7144 48.1591 11.6047 48.1031 11.4755C48.047 11.3463 48.0305 11.2033 48.0557 11.0647C48.0809 10.9261 48.1466 10.7981 48.2445 10.6969C48.3425 10.5956 48.4682 10.5257 48.6059 10.4959C48.7436 10.4661 48.887 10.4778 49.018 10.5296C49.149 10.5813 49.2617 10.6707 49.3419 10.7865C49.4221 10.9023 49.4662 11.0393 49.4685 11.1801V11.1921C49.4725 11.3769 49.4029 11.5556 49.2751 11.6891C49.1472 11.8225 48.9716 11.8997 48.7869 11.9037H48.7685L48.7683 11.9041ZM45.6505 10.1508H43.8857V7.38694C43.8857 6.72787 43.8739 5.87944 42.9677 5.87944C42.0485 5.87944 41.9079 6.59753 41.9079 7.33896V10.1506H40.143V4.46699H41.8373V5.24372H41.861C42.0306 4.95381 42.2756 4.71532 42.57 4.55364C42.8643 4.39196 43.1971 4.31316 43.5327 4.32561C45.3215 4.32561 45.6513 5.5022 45.6513 7.03287L45.6505 10.1508ZM38.1516 3.69007C37.9491 3.69011 37.7511 3.63008 37.5826 3.51757C37.4142 3.40506 37.2829 3.24513 37.2053 3.058C37.1278 2.87087 37.1074 2.66494 37.1469 2.46627C37.1864 2.26759 37.2839 2.08508 37.4271 1.94182C37.5703 1.79856 37.7528 1.70098 37.9515 1.66143C38.1501 1.62187 38.3561 1.64212 38.5432 1.7196C38.7304 1.79709 38.8904 1.92833 39.0029 2.09674C39.1155 2.26514 39.1756 2.46315 39.1756 2.66571C39.1757 2.80021 39.1492 2.93339 39.0978 3.05766C39.0463 3.18193 38.9709 3.29485 38.8758 3.38997C38.7807 3.48509 38.6678 3.56055 38.5436 3.61204C38.4193 3.66354 38.2861 3.69005 38.1516 3.69007ZM39.0341 10.1508H37.2674V4.46699H39.0341V10.1508ZM46.5304 0.00276433H36.3805C36.1502 0.000164566 35.9282 0.0891321 35.7634 0.250117C35.5985 0.411102 35.5044 0.630933 35.5016 0.861304V11.0533C35.5043 11.2838 35.5984 11.5038 35.7632 11.6649C35.928 11.8261 36.15 11.9152 36.3805 11.9128H46.5304C46.7613 11.9157 46.984 11.8268 47.1494 11.6656C47.3149 11.5045 47.4096 11.2842 47.4128 11.0533V0.860569C47.4095 0.629741 47.3147 0.40966 47.1493 0.248679C46.9838 0.0876982 46.7612 -0.00101538 46.5304 0.00202897V0.00276433ZM30.698 5.83881C29.8156 5.83881 29.2861 6.42803 29.2861 7.28657C29.2861 8.14511 29.8154 8.73487 30.698 8.73487C31.5806 8.73487 32.1112 8.14658 32.1112 7.28657C32.1112 6.42656 31.5815 5.83881 30.698 5.83881ZM33.736 10.1475H32.1112V9.39376H32.0871C31.8833 9.66792 31.6189 9.89133 31.3145 10.0466C31.0102 10.2018 30.6741 10.2847 30.3325 10.2887C28.6368 10.2887 27.5197 9.06487 27.5197 7.33418C27.5197 5.74469 28.5083 4.28517 30.1332 4.28517C30.8636 4.28517 31.5459 4.48501 31.9461 5.03892H31.9693V1.76268H33.7358L33.736 10.1475ZM25.2537 6.6457C25.2571 6.50251 25.2314 6.36013 25.1781 6.22718C25.1248 6.09423 25.0451 5.97348 24.9438 5.87224C24.8425 5.771 24.7217 5.69138 24.5887 5.6382C24.4557 5.58502 24.3133 5.55939 24.1702 5.56287C23.8618 5.54368 23.5582 5.64644 23.3249 5.849C23.0916 6.05156 22.9473 6.33769 22.923 6.6457H25.2537ZM26.7487 9.16432C26.4554 9.51997 26.0867 9.80593 25.6693 10.0015C25.2519 10.1971 24.7962 10.2974 24.3352 10.2951C22.5704 10.2951 21.1574 9.11708 21.1574 7.29282C21.1574 5.46856 22.5702 4.29105 24.3352 4.29105C25.9849 4.29105 27.0193 5.46764 27.0193 7.29282V7.84618H22.923C22.974 8.16001 23.1367 8.44484 23.3811 8.64818C23.6255 8.85152 23.9352 8.95968 24.2531 8.95272C24.5043 8.95117 24.7511 8.8868 24.9711 8.7655C25.1911 8.64419 25.3772 8.46979 25.5126 8.25817L26.7487 9.16432ZM9.20402 4.46552H10.8988V5.24225H10.9229C11.0922 4.95222 11.3371 4.71361 11.6314 4.55191C11.9257 4.39021 12.2585 4.31149 12.594 4.32414C14.3837 4.32414 14.7132 5.50165 14.7132 7.03139V10.1482H12.9483V7.38492C12.9483 6.7253 12.9362 5.87742 12.0291 5.87742C11.1117 5.87742 10.9702 6.59569 10.9702 7.33694V10.1475H9.2053L9.20402 4.46552ZM15.6081 1.76323H17.373V6.77567L19.3732 4.46239H21.537L19.2206 7.09372L21.4883 10.151H19.2701L17.3965 7.34154H17.3734V10.1506H15.6085L15.6081 1.76323ZM6.46055 4.46497H8.22543V10.1486H6.46055V4.46497ZM7.34299 1.63932C7.54547 1.63936 7.7434 1.69943 7.91174 1.81195C8.08008 1.92448 8.21128 2.08439 8.28874 2.27147C8.3662 2.45855 8.38645 2.6644 8.34692 2.86298C8.3074 3.06157 8.20988 3.24398 8.06669 3.38715C7.9235 3.53031 7.74107 3.6278 7.54248 3.66729C7.34388 3.70678 7.13804 3.68649 6.95097 3.609C6.7639 3.5315 6.60402 3.40028 6.49153 3.23192C6.37904 3.06356 6.319 2.86562 6.319 2.66314C6.319 2.52867 6.34548 2.39552 6.39695 2.2713C6.44841 2.14707 6.52384 2.0342 6.61893 1.93913C6.71402 1.84405 6.8269 1.76864 6.95114 1.7172C7.07537 1.66576 7.20853 1.6393 7.34299 1.63932ZM0.410156 1.76452H2.24728V8.45635H5.64834V10.1517H0.410156V1.76452ZM48.8972 11.2364C48.9274 11.2367 48.9574 11.2308 48.9852 11.219C49.013 11.2073 49.0382 11.1899 49.059 11.168C49.0799 11.1462 49.096 11.1202 49.1065 11.0919C49.1169 11.0635 49.1214 11.0333 49.1196 11.0031C49.1196 10.8377 49.0198 10.7586 48.815 10.7586H48.4841V11.6249H48.6085V11.2472H48.7615L48.765 11.2518L49.0023 11.6249H49.1354L48.8801 11.2388L48.8972 11.2364ZM48.7532 11.1496H48.6089V10.8568H48.7918C48.8863 10.8568 48.994 10.8722 48.994 10.9959C48.994 11.1382 48.885 11.1496 48.7525 11.1496"
                    fill="#0A66C2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4158_4439">
                    <rect
                      width="49.1803"
                      height="12"
                      fill="white"
                      transform="translate(0.410156)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div class="mt-2">
            <div class="flex flex__center flex__gap-1">
              <button>
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1693 0.499591C18.3713 1.06249 17.4877 1.49302 16.5526 1.77459C16.0507 1.19752 15.3837 0.788501 14.6418 0.602862C13.8999 0.417224 13.1188 0.46392 12.4043 0.736635C11.6898 1.00935 11.0763 1.49493 10.6468 2.12769C10.2172 2.76045 9.99235 3.50987 10.0026 4.27459V5.10792C8.53813 5.1459 7.087 4.8211 5.77844 4.16246C4.46989 3.50382 3.34453 2.53179 2.5026 1.33292C2.5026 1.33292 -0.830729 8.83292 6.66927 12.1663C4.95304 13.3312 2.90857 13.9154 0.835938 13.8329C8.33594 17.9996 17.5026 13.8329 17.5026 4.24959C17.5018 4.01747 17.4795 3.78592 17.4359 3.55792C18.2864 2.71917 18.8866 1.66018 19.1693 0.499591Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </button>
              <button>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.1641 1.66602H5.83073C3.52954 1.66602 1.66406 3.5315 1.66406 5.83268V14.166C1.66406 16.4672 3.52954 18.3327 5.83073 18.3327H14.1641C16.4653 18.3327 18.3307 16.4672 18.3307 14.166V5.83268C18.3307 3.5315 16.4653 1.66602 14.1641 1.66602Z"
                    fill="#1D1D1D"
                  />
                  <path
                    d="M13.3337 9.47525C13.4366 10.1688 13.3181 10.8771 12.9952 11.4994C12.6723 12.1218 12.1614 12.6264 11.5351 12.9416C10.9088 13.2569 10.1991 13.3666 9.5069 13.2552C8.81468 13.1438 8.17521 12.817 7.67944 12.3212C7.18367 11.8254 6.85685 11.186 6.74546 10.4938C6.63408 9.80154 6.74379 9.09183 7.05901 8.46556C7.37423 7.8393 7.8789 7.32837 8.50123 7.00545C9.12356 6.68254 9.83187 6.56407 10.5254 6.66692C11.2328 6.77182 11.8878 7.10147 12.3935 7.60717C12.8992 8.11288 13.2288 8.76781 13.3337 9.47525Z"
                    stroke="#F9FAFB"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5859 5.41602H14.5943"
                    stroke="#F9FAFB"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button>
                <svg
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0026 0.666016H7.5026C6.39754 0.666016 5.33773 1.105 4.55633 1.8864C3.77492 2.66781 3.33594 3.72761 3.33594 4.83268V7.33268H0.835938V10.666H3.33594V17.3327H6.66927V10.666H9.16927L10.0026 7.33268H6.66927V4.83268C6.66927 4.61167 6.75707 4.39971 6.91335 4.24343C7.06963 4.08715 7.28159 3.99935 7.5026 3.99935H10.0026V0.666016Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import mediaQuery from "@/mixins/mediaQuery";

export default {
  name: "LandingPageLayout",
  mixins: [mediaQuery],
  components: {
    Footer
  },
  data() {
    return {
      showMenu: false,
      navLinks: [
        {
          link: "hire-talent",
          name: "Hire Talent"
        },
        {
          link: "find-job",
          name: "Find a Job"
        },
        {
          link: "services",
          name: "Services"
        },
        {
          link: "about-us",
          name: "About"
        }
      ]
    };
  },
  watch: {
    showMenu(val) {
      if (val) {
        document.body.style.overflow = "hidden";
        return;
      }

      document.body.style.overflow = "auto";
    },
    onMobileView(value) {
      if (!value) document.body.style.overflow = "auto";
      this.showMenu = false;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  beforeDestroy() {
    document.body.style.overflow = "auto";
  }
};
</script>

<style scoped lang="scss">
@use "../../assets/scss/mixins/index" as *;

main {
  min-height: 100vh;
}

.nav {
  padding: 17px 5%;
  background: #ffffff;
  border-bottom: 1px solid #f2f4f7;

  &__link {
    transition: 0.3s all ease-out;

    &.exact-active {
      color: #101828;
      font-weight: 600;
    }

    &:hover {
      color: #0385f3;
    }
  }

  &__menu-slider {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;

    &__overlay {
      width: 100%;
      height: 100%;
      background: #1d1d1d;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s all ease-out;
    }

    &__card {
      width: 90%;
      height: 100vh;
      background: #fff;
      position: absolute;
      top: 0;
      right: -100%;
      overflow: scroll;
      padding-top: 84px;
      transition: 0.3s all cubic-bezier(0.895, 0.03, 0.685, 0.22);
    }

    &.active {
      pointer-events: auto;

      & .nav__menu-slider__overlay {
        width: 100%;
        height: 100%;
        background: #1d1d1d;
        opacity: 0.8;
        visibility: visible;
      }

      & .nav__menu-slider__card {
        right: -0;
      }
    }

    &__items {
      padding: 0 32px;
    }

    &__item {
      padding: 36px;

      &:not(:last-child) {
        border-bottom: 1px solid #eaecf0;

        &.exact-active {
          font-weight: bold;
        }
      }

      &:last-child {
        color: #797ef6;

        &.exact-active {
          font-weight: bold;
        }
      }
    }

    &__bottom {
      background: #f9fafb;
      border-radius: 4px;
      padding: 16px;

      & > :first-child {
        padding: 0 20px;
        padding-bottom: 16px;
        border-bottom: 1px solid #eaecf0;
      }
    }
  }

  @include query("mobile") {
    padding: 5px 5%;
  }
}

.hamburger__icon {
  gap: 8px;

  &-item {
    height: 2px;
    width: 32px;
    border-radius: 4px;
    background: #000;
  }
}

.auto__scroller {
  bottom: 40px;
  right: 40px;
}

.fixed-nav {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
}

.after-fixed-header {
  margin-top: 108px;
  @include query("mobile") {
    margin-top: 85px;
  }
}

.fixed-menu-slider {
  margin-top: 108px;
  @include query("mobile") {
    margin-top: 85px;
  }
}
</style>
